import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('stripe-payment-methods', (editor, opts = {}) => {
  const default_types = {
    stripeButton: 'stripe-payment-methods',
  };
  const default_labels = {
    stripeButton: 'Stripe Payment Methods',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Payment Gateway',
    },
    ...opts,
  };

  loadComponents(editor, options);
});
